import React from 'react';
import ModalButton from '../UI/ModalButton';
import LanguageSwitcher from '../UI/LanguageSwitcher';
import { useLanguage } from '../../context/LanguageContext';

interface ExpiredDialogProps {
  onBackToMerchant?: () => void;
}

const ExpiredDialog: React.FC<ExpiredDialogProps> = ({
  onBackToMerchant
}) => {
  const { t } = useLanguage();

  const CloseIcon = () => (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 14L42 42M42 14L14 42"
        stroke="#EF4444"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className="expired-dialog">
      <div className="dialog-header">
        <LanguageSwitcher />
      </div>
      <div className="expired-dialog__content-wrapper">
        <div className="expired-dialog__icon">
          <div className="expired-dialog__icon-inner">
            <CloseIcon />
          </div>
        </div>

        <div className="expired-dialog__content">
          <h2 className="expired-dialog__title">{t('expired')}</h2>
          <p className="expired-dialog__desc">{t('expiredDescription')}</p>
          <p className="expired-dialog__hint">{t('expiredHint')}</p>
        </div>
      </div>

      {onBackToMerchant && (
        <div className="expired-dialog__actions">
          <ModalButton
            variant="primary"
            onClick={onBackToMerchant}
          >
            {t('backToMerchant')}
          </ModalButton>
        </div>
      )}
    </div>
  );
};

export default ExpiredDialog;
